import {defineAsyncComponent} from 'vue';

const popupBudgetChapterDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/budgetChapter/BudgetChapterDetail.vue'),
);
const budgetChapterTransfer = defineAsyncComponent(() =>
  import('@/views/dictionary/budgetChapter/BudgetChapterTransfer.vue'),
);
const popupStockDetail = defineAsyncComponent(() => import('@/views/dictionary/stock/StockDetail.vue'));
const popupBudgetsource = defineAsyncComponent(() => import('@/views/dictionary/budgetSource/BudgetSourceDetail.vue'));
const popupBankInfoCategoryDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/bankInfoCategory/BankInfoCategoryDetail.vue'),
);
const popupBudgetSourcePropertyDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/budgetSourceProperty/BudgetSourcePropertyDetail.vue'),
);
const popupBudgetKindItemDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/budgetKindItem/BudgetKindItemDetail.vue'),
);
const budgetKindItemTransfer = defineAsyncComponent(() =>
  import('@/views/dictionary/budgetKindItem/BudgetKindItemTransfer.vue'),
);
const popupSystemAccountsTransfer = defineAsyncComponent(() =>
  import('@/views/dictionary/systemAccounts/SystemAccountsTransfer.vue'),
);
const popupSystemAccountDetails = defineAsyncComponent(() =>
  import('@/views/dictionary/systemAccounts/SystemAccountDetails.vue'),
);
const popupBudgetGroupItem = defineAsyncComponent(() =>
  import('@/views/dictionary/budgetGroupItem/BudgetGroupItemDetail.vue'),
);

const popupBUPlanReportPopup = defineAsyncComponent(() =>
  import('@/views/budgetPlan/buPlanReport/BUPlanReportPopup.vue'),
);

const popupAccountingObjectCategoryDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/accountingObjectCategory/AccountingObjectCategoryDetail.vue'),
);
// Chi tiết danh mục ngạch lương
const popupSalaryScaleDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/salaryScale/SalaryScaleDetail.vue'),
);
const popupBankInfoDetail = defineAsyncComponent(() => import('@/views/dictionary/bankInfo/BankInfoDetail.vue'));
const popupDefaultAccountDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/defaultAccount/DefaultAccountDetail.vue'),
);
// Chi tiết danh mục loại vật tư/ ccdc
const popupEquipmentInventoryItemDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/stock/EquipmentInventoryItemDetail.vue'),
);

// Thiết lập ngầm định
const defaultImplicitSetting = defineAsyncComponent(() =>
  import('@/views/dictionary/defaultImplicitSetting/DefaultImplicitSetting.vue'),
);
// Chế độ ghi sổ
const regimePosted = defineAsyncComponent(() => import('@/views/dictionary/regimePosted/RegimePosted.vue'));
const popupInventoryCategoryDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/stock/InventoryCategoryDetail.vue'),
);
// Lịch sử cập nhật báo cáo
const reportUpdateHistory = defineAsyncComponent(() =>
  import('@/views/dictionary/reportUpdateHistory/ReportUpdateHistory.vue'),
);

// Chi tiết Danh mục phòng ban
const popupDepartmentDetail = defineAsyncComponent(() => import('@/views/dictionary/department/DepartmentDetail.vue'));

const popupFixedAssetCategoryDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/fixedAssetCategory/FixedAssetCategoryDetail.vue'),
);

const popupAccountTransferDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/accountTransfer/AccountTransferDetail.vue'),
);
const popupAutoBusinessDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/autoBusiness/AutoBusinessDetail.vue'),
);
const popupBudgetProvideDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/budgetProvide/BudgetProvideDetail.vue'),
);

const popupBudgetitemSpendDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/budgetitemSpend/BudgetitemSpendDetail.vue'),
);
const popupBudgetItemCollectDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/budgetItemCollect/BudgetItemCollectDetail.vue'),
);
const popupEmployeeIncomeTaxDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/salaryScale/EmployeeIncomeTaxDetail.vue'),
);
const popupFundDetail = defineAsyncComponent(() => import('@/views/dictionary/fund/FundDetail.vue'));
const popupFixedAssetDetail = defineAsyncComponent(() => import('@/views/dictionary/fixedAsset/FixedAssetDetail.vue'));
const popupAccountingObjectDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/accountingObject/AccountingObjectDetail.vue'),
);
const accountingObjectListDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/accountingObjectList/AccountingObjectMasterDetail.vue'),
);

const popupInventoryDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/stock/inventory/InventoryDetail.vue'),
);
const importExcel = defineAsyncComponent(() => import('@/views/common/import/ImportExcel.vue'));
const activityCategoryDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/activityCategory/ActivityCategoryDetail.vue'),
);
const hamletDetail = defineAsyncComponent(() => import('@/views/dictionary/hamlet/HamletDetail.vue'));
const popupActivityDetail = defineAsyncComponent(() => import('@/views/dictionary/activity/ActivityDetail.vue'));
const popupBranchDetail = defineAsyncComponent(() => import('@/views/dictionary/branch/BranchDetail.vue'));

const statisticDetail = defineAsyncComponent(() => import('@/views/dictionary/statistic/StatisticDetail.vue'));

const contractDetail = defineAsyncComponent(() => import('@/views/dictionary/contract/ContractDetail.vue'));

const popupSubBudgetItemDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/subBudgetItem/SubBudgetItemDetail.vue'),
);
// Chi tiết danh mục nội dung chi phí
const fundStructureDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/fundStructure/FundStructureDetail.vue'),
);

const popupBudgetSourceTransfer = defineAsyncComponent(() =>
  import('@/views/dictionary/budgetSource/BudgetSourceTransfer.vue'),
);

// Biểu tính thuế thu nhập (quy định lương, thuế, bảo hiểm)
const paOption = defineAsyncComponent(() => import('@/views/dictionary/salaryScale/paOption/PAOption.vue'));

// Danh mục khác -> Khoản chi xã
const localBudgetItemDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/localBudgetItem/LocalBudgetItemDetail.vue'),
);
// const lockLedgerTest = defineAsyncComponent(() => import('@/views/summary/suLockLedger/LockLedgerVoucher.vue'));
const UnlockLedgerVoucher = defineAsyncComponent(() => import('@/views/summary/suLockLedger/UnLockLedgerVoucher.vue'));
const accountTypeDetail = defineAsyncComponent(() => import('@/views/dictionary/bankInfo/AccountTypeDetail.vue'));

// popup chương trình mục tiêu, dự án
const projectTarget = defineAsyncComponent(() => import('@/views/dictionary/project/ProjectTarget.vue'));
const projectDetail = defineAsyncComponent(() => import('@/views/dictionary/project/ProjectDetail.vue'));
const projectConstruction = defineAsyncComponent(() => import('@/views/dictionary/project/ProjectConstruction.vue'));

// Popup Thiết lập báo cáo tài chính
const CellReportSetting = defineAsyncComponent(() =>
  import('@/views/system/financeReportSetting/CellReportSetting.vue'),
); // Form chi tiết
const SummaryReportSetting = defineAsyncComponent(() =>
  import('@/views/system/financeReportSetting/SummaryReportSetting.vue'),
);

// Form chi tiết
//form tùy chọn trên các cột tiền
const CustomMoneyColumn = defineAsyncComponent(() =>
  import('@/views/dictionary/settingFinancialReport/customMoneyColumn/CustomMoneyColumn.vue'),
);

//form thiết lập công thức tính
const SettingFormula = defineAsyncComponent(() =>
  import('@/views/dictionary/settingFinancialReport/settingFormula/SettingFormula.vue'),
);
// const FinanceReportSetting_16QTDA = defineAsyncComponent(() => import('@/views/system/financeReportSetting/FinanceReportSetting_16QTDA.vue')); // Mẫu số 16/QTDA: Bảng đối chiếu số liệu sử dụng nguồn vốn đầu tư

// popup ẩn hiện cột - htthoa (31/5/2023)
const popupHideShowColumn = defineAsyncComponent(() => import('@/views/dictionary/hideShowColumn/HideShowColumn.vue'));
const popupCustomTemplate = defineAsyncComponent(() => import('@/views/dictionary/customTemplate/CustomTemplate.vue'));
const popupSettingFinancialReport = defineAsyncComponent(() =>
  import('@/views/dictionary/settingFinancialReport/SettingFinancialReport.vue'),
);
const popupCustomTemplateDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/customTemplate/CustomTemplateDetail.vue'),
);
const popupSettingFinancialReportDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/settingFinancialReport/settingFinancialReportDetail/SettingFinancialReportDetail.vue'),
);
const popupTemplateDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/customTemplate/CustomDetailTemplate.vue'),
);
const PopupColumnsReportDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/customTemplate/ColumnsReportDetail.vue'),
);

const PopupTargetForRowOnReportTab = defineAsyncComponent(() =>
  import('@/views/dictionary/customTemplate/TargetForRowOnReportTab.vue'),
);
const PopupHideMoney = defineAsyncComponent(() => import('@/views/dictionary/customTemplate/PopupHideMoney.vue'));
const PopupShowContent = defineAsyncComponent(() => import('@/views/dictionary/customTemplate/PopupShowContent.vue'));
const PopupSaveNewTemplate = defineAsyncComponent(() =>
  import('@/views/dictionary/customTemplate/PopupSaveNewTemplate.vue'),
);

const popupCustomTemplateColor = defineAsyncComponent(() =>
  import('@/views/dictionary/customTemplateColor/CustomTemplateColor.vue'),
);

const popupSelectCertificateEsign = defineAsyncComponent(() =>
  import('@/views/dictionary/settingEsign/SelectCertificateEsign.vue'),
);

const popupESignConnect = defineAsyncComponent(() => import('@/views/dictionary/settingEsign/ESignConnect.vue'));

const popupDumpDataDvc = defineAsyncComponent(() => import('@/views/dictionary/DumpDataDvc/DumpDataDvc.vue'));

const popupExpenseNormRegulationDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/expenseNormRegulation/ExpenseNormRegulationDetail.vue'),
);

export function registerDictionary(app) {
  app.component('BudgetChapterDetail', popupBudgetChapterDetail);
  app.component('BudgetChapterTransfer', budgetChapterTransfer);
  app.component('BudgetSourceDetail', popupBudgetsource);
  app.component('BudgetSourcePropertyDetail', popupBudgetSourcePropertyDetail);
  app.component('BudgetKindItemDetail', popupBudgetKindItemDetail);
  app.component('BudgetKindItemTransfer', budgetKindItemTransfer);
  app.component('SystemAccountDetails', popupSystemAccountDetails);
  app.component('BUPlanReportPopup', popupBUPlanReportPopup);
  app.component('SystemAccountsTransfer', popupSystemAccountsTransfer);
  app.component('SalaryScaleDetail', popupSalaryScaleDetail);
  app.component('StockDetail', popupStockDetail);
  app.component('BankInfoCategoryDetail', popupBankInfoCategoryDetail);
  app.component('BankInfoDetail', popupBankInfoDetail);
  app.component('AccountTransferDetail', popupAccountTransferDetail);
  app.component('AutoBusinessDetail', popupAutoBusinessDetail);
  app.component('BudgetProvideDetail', popupBudgetProvideDetail);
  app.component('FixedAssetCategoryDetail', popupFixedAssetCategoryDetail);
  app.component('BudgetItemCollectDetail', popupBudgetItemCollectDetail);
  app.component('BudgetitemSpendDetail', popupBudgetitemSpendDetail);
  app.component('DefaultAccountDetail', popupDefaultAccountDetail);
  app.component('BudgetGroupItemDetail', popupBudgetGroupItem);
  app.component('EquipmentInventoryItemDetail', popupEquipmentInventoryItemDetail);
  app.component('AccountingObjectCategoryDetail', popupAccountingObjectCategoryDetail);
  app.component('InventoryCategoryDetail', popupInventoryCategoryDetail);
  app.component('EmployeeIncomeTaxDetail', popupEmployeeIncomeTaxDetail);
  app.component('FundDetail', popupFundDetail);
  app.component('ActivityDetail', popupActivityDetail);
  app.component('DepartmentDetail', popupDepartmentDetail);
  app.component('ActivityCategoryDetail', activityCategoryDetail);
  app.component('BranchDetail', popupBranchDetail);
  app.component('FixedAssetDetail', popupFixedAssetDetail);
  app.component('AccountingObjectDetail', popupAccountingObjectDetail);
  app.component('InventoryDetail', popupInventoryDetail);
  app.component('AccountingObjectListDetail', accountingObjectListDetail);
  app.component('HamletDetail', hamletDetail);
  app.component('StatisticDetail', statisticDetail);
  app.component('ContractDetail', contractDetail);
  app.component('SubBudgetItemDetail', popupSubBudgetItemDetail);
  app.component('FundStructureDetail', fundStructureDetail);
  app.component('BudgetSourceTransfer', popupBudgetSourceTransfer);
  app.component('PAOption', paOption);
  app.component('LocalBudgetItemDetail', localBudgetItemDetail);
  // app.component('LockLedgerTest', lockLedgerTest);
  app.component('UnlockLedgerVoucher', UnlockLedgerVoucher);
  app.component('AccountTypeDetail', accountTypeDetail);
  app.component('DefaultImplicitSetting', defaultImplicitSetting);
  app.component('ProjectTarget', projectTarget);
  app.component('ProjectDetail', projectDetail);
  app.component('ProjectConstruction', projectConstruction);
  app.component('RegimePosted', regimePosted);
  app.component('ReportUpdateHistory', reportUpdateHistory);
  app.component('ImportExcel', importExcel);
  app.component('CellReportSetting', CellReportSetting);
  app.component('SummaryReportSetting', SummaryReportSetting);
  app.component('CustomMoneyColumn', CustomMoneyColumn);
  app.component('SettingFormula', SettingFormula);
  app.component('HideShowColumn', popupHideShowColumn);
  app.component('CustomTemplate', popupCustomTemplate);
  app.component('SettingFinancialReport', popupSettingFinancialReport);
  app.component('CustomTemplateDetail', popupCustomTemplateDetail);
  app.component('SettingFinancialReportDetail', popupSettingFinancialReportDetail);
  app.component('ColumnsReportDetail', PopupColumnsReportDetail);
  app.component('PopupHideMoney', PopupHideMoney);
  app.component('PopupShowContent', PopupShowContent);
  app.component('TemplateDetail', popupTemplateDetail);
  app.component('TargetForRowOnReportTab', PopupTargetForRowOnReportTab);
  app.component('SaveNewTemplate', PopupSaveNewTemplate);
  app.component('CustomTemplateColor', popupCustomTemplateColor);
  app.component('SelectCertificateEsign', popupSelectCertificateEsign);
  app.component('ESignConnect', popupESignConnect);
  app.component('DumpDataDvc', popupDumpDataDvc);
  app.component('ExpenseNormRegulationDetail', popupExpenseNormRegulationDetail);
}
